import { useQuery } from '@tanstack/react-query';
import { DateRange } from 'react-day-picker';

import { fetchNewsFrequency } from '@/lib/api/news';
import { TimeWindow } from '@/types';

export type NewsFrequencyOptions = {
  dateRange?: DateRange;
  enabled?: boolean;
  timezone?: string;
};

export const useNewsFrequencyData = (
  symbol: string,
  timeWindow: TimeWindow,
  options?: NewsFrequencyOptions
) => {
  const {
    dateRange,
    enabled = true,
    timezone: timezoneOverride,
  } = options ?? {};
  const from = dateRange?.from?.getTime();
  const to = dateRange?.to?.getTime();
  const timezone =
    timezoneOverride ??
    (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function'
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : undefined);

  return useQuery({
    queryKey: ['news-frequency', symbol, timeWindow, from, to, timezone],
    queryFn: ({ signal }) =>
      fetchNewsFrequency({
        symbol,
        timeWindow,
        from,
        to,
        timezone,
        signal,
      }),
    enabled: enabled && !!symbol && symbol !== 'N/A',
    staleTime: 0,
    gcTime: 0,
    retry: 1,
  });
};
